module.exports = __webpack_public_path__ + "static/social-proof-3-5427b9285c87312632a633926796f4ce.jpg";